import "core-js/modules/es.function.name.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/es.string.iterator.js";
import "core-js/modules/web.dom-collections.iterator.js";
import { required, type } from "@/commons/utils/Rules";
import { getEstadoCivil, getRelacionesLaborales } from "@/routes/api/resources";
import 'element-ui/lib/theme-chalk/display.css';
import PzBaseForm1 from "@/components/Flujo/Formularios/Formularios1/baseForm1";
import PzFormFlujo from "@/components/Flujo/Templates/PzFormFlujoTemplate";
import PzIdentityDocument from "@/commons/forms/Fields/PzIdentityDocument.vue";
export default {
  name: 'PzPersonForm2Oca',
  components: {
    PzIdentityDocument: PzIdentityDocument,
    PzFormFlujo: PzFormFlujo
  },
  mixins: [PzBaseForm1],
  data: function data() {
    return {
      reference: 'formulario1',
      marital_status: [],
      relacion_laboral: [],
      formulario1: {
        estado_civil_id: '',
        relacion_laboral_id: '',
        ingreso_mensual: '',
        identity_conyugue: ""
      },
      rules_formulario1: {
        estado_civil_id: [required('')],
        relacion_laboral_id: [required('')],
        ingreso_mensual: [required(''), type({
          field: '',
          type: 'number'
        })]
      },
      pickerOptions1: {
        disabledDate: function disabledDate(time) {
          return Date.now() < time.getTime();
        }
      }
    };
  },
  created: function created() {
    this.fetchData();
  },
  methods: {
    fetchData: function fetchData() {
      var _this = this;
      this.$store.dispatch('loader/up', {
        trigger: this.$options.name
      });
      var estado = getEstadoCivil().then(function (res) {
        _this.marital_status = res.data;
      }).catch(function () {
        _this.marital_status = [];
      });
      var re = getRelacionesLaborales().then(function (res) {
        _this.relacion_laboral = res.data;
      }).catch(function () {
        _this.relacion_laboral = [];
      });
      return Promise.all([estado, re]).then(function () {}).finally(function () {
        _this.$store.dispatch('loader/down', {
          trigger: _this.$options.name
        });
      });
    }
  }
};